import * as React from 'react';
import Box from '@mui/material/Box';
import TalentRealm2 from '../../assets/TalentRealm2.svg';

export default function SitemarkIcon() {
  return (
    <Box
      component="img"
      src={TalentRealm2}
      alt="TalentRealm Logo"
      sx={{ height: 25, ml: 2 }}
    />
  );
}
